
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
 
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Cleans up AI-generated text by removing backticks and language identifiers.
 * @param rawText The raw text response from the AI.
 * @returns The cleaned text, ready for display.
 */
export const cleanupAIResponse = (rawText: string): string => {
  // Removes ```json, ```javascript, ```, etc., from the start and end of the string.
  return rawText.replace(/^(```[a-zA-Z]*\n)|(```)$/g, '').trim();
};

/**
 * Converts a base64 data URL into a File object.
 * @param dataUrl The base64 data URL (e.g., from a canvas or file reader).
 * @param filename The desired filename for the resulting file.
 * @returns A File object.
 */
export function dataURLtoFile(dataUrl: string, filename: string): File {
    const arr = dataUrl.split(',');
    if (arr.length < 2) {
        throw new Error('Invalid data URL');
    }
    const mimeMatch = arr[0].match(/:(.*?);/);
    if (!mimeMatch || mimeMatch.length < 2) {
        throw new Error('Could not determine mime type from data URL');
    }
    const mime = mimeMatch[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type:mime});
}
